module.exports = __webpack_public_path__ + "static/chocolate_main-01f371f62bac9ccb1b1d9299d885c5b4.jpeg";